const FilmReel = () => {
  const travelImages = [
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-fr-par_2.jpg",
      attraction: "Notre-Dame Cathedral",
      location: "Paris, France"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-uk-lon_3.jpg",
      attraction: "Tower Bridge",
      location: "London, UK"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-us-nyc_7.jpg",
      attraction: "Bathesda Terrace",
      location: "New York, USA"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-it-rom_11.jpg",
      attraction: "Castel Sant'Angelo",
      location: "Rome, Italy"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-jp-kyo_20.jpg",
      attraction: "Kiyomizu-dera Temple",
      location: "Kyoto, Japan"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-es-bcn_4.jpg",
      attraction: "Casa Batlló",
      location: "Barcelona, Spain"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-de-ber_3.jpg",
      attraction: "Oberbaumbrücke",
      location: "Berlin, Germany"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-nl-ams_10.jpg",
      attraction: "Canal District",
      location: "Amsterdam, Netherlands"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-at-vie_15.jpg",
      attraction: "Plague Column",
      location: "Vienna, Austria"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-cn-pek_12.jpg",
      attraction: "Xuanwu Lake Park",
      location: "Nanjing, China"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-cz-prg_8.jpg",
      attraction: "St. Vitus Cathedral",
      location: "Prague, Czech Republic"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-eg-cai_7.jpg",
      attraction: "Qalawun Mosque",
      location: "Cairo, Egypt"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-es-mad_9.jpg",
      attraction: "Plaza Mayor",
      location: "Madrid, Spain"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-gr-ath_6.jpg",
      attraction: "Mount Lycabettus",
      location: "Athens, Greece"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-it-ven_14.jpg",
      attraction: "St. Mark's Basilica",
      location: "Venice, Italy"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-ma-rak_16.jpg",
      attraction: "El Badi Palace",
      location: "Marrakech, Morocco"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-tr-ist_25.jpg",
      attraction: "Dolmabahçe Palace",
      location: "Istanbul, Turkey"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-es-grx_13.jpg",
      attraction: "Alhambra",
      location: "Granada, Spain"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-it-flo_1.jpg",
      attraction: "Duomo di Firenze",
      location: "Florence, Italy"
    },
    {
      url: "https://travelmaker-artefacts.s3.eu-north-1.amazonaws.com/city-es-cba_6.jpg",
      attraction: "Mezquita-Catedral",
      location: "Córdoba, Spain"
    }
  ];

  const leftColumn = travelImages.slice(0, 10);
  const rightColumn = travelImages.slice(10, 20);

  return (
    <>
      {/* Desktop: Vertical strips (hidden on mobile/tablet) */}
      <div className="hidden lg:flex gap-4 xl:gap-8 h-screen pr-20 xl:pr-10 relative">
        {/* Single strip for smaller screens, two strips for larger screens */}
        <div className="flex-1 h-full px-6 overflow-hidden relative">
          <div className="flex flex-col animate-scroll-up gap-20 py-4">
            {[...leftColumn, ...leftColumn].map((image, index) => (
              <div key={`left-${index}`} className="w-full aspect-[2/3] flex-shrink-0 relative film-frame group">
                <img src={image.url} alt={`${image.attraction} in ${image.location}`} className="w-full h-full object-cover block rounded-2xl shadow-lg" />

                {/* Caption overlay */}
                <div className="absolute bottom-[-30px] left-0 right-0 px-12 text-black text-center">
                  <div className="bg-white backdrop-blur-sm rounded-lg p-3 shadow-[0_16px_40px_-8px_rgba(0,0,0,0.25)]">
                    <h4 className="font-semibold text-lg mb-1 leading-tight">{image.attraction}</h4>
                    <p className="text-md leading-tight">{image.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Second strip only visible on xl screens and above */}
        <div className="hidden xl:block pr-6 flex-1 h-full overflow-hidden relative">
          <div className="flex flex-col animate-scroll-down gap-20 py-4">
            {[...rightColumn, ...rightColumn].map((image, index) => (
              <div key={`right-${index}`} className="w-full aspect-[2/3] flex-shrink-0 relative film-frame group">
                <img src={image.url} alt={`${image.attraction} in ${image.location}`} className="w-full h-full object-cover block rounded-2xl shadow-lg" />

                {/* Caption overlay */}
                <div className="absolute bottom-[-30px] left-0 right-0 px-12 text-black text-center">
                  <div className="bg-white backdrop-blur-sm rounded-lg p-3 shadow-[0_16px_40px_-8px_rgba(0,0,0,0.25)]">
                    <h4 className="font-semibold text-lg mb-1 leading-tight">{image.attraction}</h4>
                    <p className="text-md leading-tight">{image.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile/Tablet: Horizontal scrolling strip */}
      <div className="lg:hidden w-full h-64 sm:h-80 md:h-96 overflow relative rounded-2xl">
        {/* Gradient overlays for better text readability */}
        {/* <div className="absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-black/20 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-black/20 to-transparent z-10 pointer-events-none"></div> */}

        <div className="flex animate-scroll-horizontal h-full" style={{width: 'calc(200% + 16px)'}}>
          {[...travelImages, ...travelImages].map((image, index) => (
            <div key={`mobile-${index}`} className="w-40 sm:w-48 md:w-56 h-full flex-shrink-0 relative film-frame mr-8 first:ml-4 group">
              <img src={image.url} alt={`${image.attraction} in ${image.location}`} className="w-full h-full object-cover block rounded-2xl shadow-lg" />
              {/* <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent rounded-2xl"></div> */}

              {/* Caption overlay for mobile */}
              <div className="absolute bottom-[-50px] left-0 right-0 p-7 text-black text-center ">
                <div className="bg-white backdrop-blur-sm rounded-lg p-2 shadow-[0_16px_40px_-8px_rgba(0,0,0,0.25)]">
                  <h4 className="font-semibold text-xs mb-1 leading-tight">{image.attraction}</h4>
                  <p className="text-xs leading-tight">{image.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};





const Home = () => {
  return (
    <main className="bg-gradient-to-b from-white via-gray-50/30 to-white">
      {/* Hero Section with modern gradient background */}
      <section className="relative overflow-hidden p-0">
        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-72 h-72 bg-primary/5 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl animate-pulse delay-1000"></div>
        </div>

        {/* Desktop Layout: Side by side */}
        <div className="hidden lg:grid lg:grid-cols-2 lg:items-start lg:h-screen">
          {/* Hero Content with enhanced typography and spacing */}
          <div className="relative z-10 px-10 py-15 flex flex-col justify-center self-center">
            {/* Hero Badge */}
            <div className="inline-flex items-center px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium mb-8 w-fit">
              <span className="w-2 h-2 bg-primary rounded-full mr-2 animate-pulse"></span>
              A travel companion like no other
            </div>

            {/* Hero Title with enhanced typography */}
            <h1 className="text-6xl xl:text-7xl mb-8 text-gray-900 font-bold leading-tight">
              <span className="bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
                TravelMaker - The Best Travel Audio Guide App
              </span>
            </h1>

            {/* Hero Subtitle with better spacing and typography */}
            <p className="text-xl xl:text-2xl mb-12 text-gray-600 max-w-2xl leading-relaxed">
  Your AI-powered travel audio guide for museums, cities, and landmarks. Get professional audio tours on your phone - free for iOS & Android.
</p>

            {/* Enhanced Button Group */}
            <div className="flex gap-6 mb-8">
              <a
                href="https://apps.apple.com/app/travelmaker-ai/id6742571605"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-lg"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                  alt="Download on the App Store"
                  className="h-15 w-44 object-contain block"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.comrades.travelmaker"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-lg"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                  className="h-15 w-44 object-contain block"
                />
              </a>
            </div>
          </div>
          <FilmReel />
        </div>

        {/* Mobile/Tablet Layout: Stacked */}
        <div className="lg:hidden py-20 px-5">
          {/* Hero Content */}
          <div className="relative z-10 text-center mb-12">
            {/* Hero Badge */}
            <div className="inline-flex items-center px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium mb-8">
              <span className="w-2 h-2 bg-primary rounded-full mr-2 animate-pulse"></span>
              A travel companion like no other
            </div>

            {/* Hero Title */}
            <h1 className="text-4xl md:text-5xl mb-8 text-gray-900 font-bold leading-tight">
              <span className="bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
                TravelMaker - The Best Travel Audio Guide App
              </span>
            </h1>

            {/* Hero Subtitle */}
            <p className="text-lg md:text-xl mb-12 text-gray-600 leading-relaxed">
  Your AI-powered travel audio guide for museums, cities, and landmarks. Get professional audio tours on your phone - free for iOS & Android.
</p>

            {/* Button Group */}
            <div className="flex flex-col items-center gap-4 mb-12">
              <a
                href="https://apps.apple.com/app/travelmaker-ai/id6742571605"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-lg"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                  alt="Download on the App Store"
                  className="h-15 w-44 object-contain block"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.comrades.travelmaker"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-lg"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                  className="h-15 w-44 object-contain block"
                />
              </a>
            </div>
          </div>

          {/* Horizontal Film Reel */}
          <FilmReel />
        </div>
      </section>

      {/* Features Section with modern design */}
      <section className="relative py-32 bg-gradient-to-b from-gray-50 to-white">
        {/* Background decoration */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-0 left-1/4 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-blue-500/5 rounded-full blur-3xl"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-5">
          {/* Section Header */}
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Powerful Features for Every Traveler
            </h2>
            <div className="w-24 h-1 bg-primary mx-auto rounded-full mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Everything you need to make your travel experience seamless and memorable
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Feature Cards with enhanced design */}
            <div className="group bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="w-16 h-16 bg-gradient-to-br from-primary/20 to-primary/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <div className="text-3xl">🎧</div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Audio Guides</h3>
              <p className="text-gray-600 leading-relaxed">Listen to AI-enhanced  narrations about historical sites and cultural landmarks as you explore.</p>
            </div>

            <div className="group bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="w-16 h-16 bg-gradient-to-br from-primary/20 to-primary/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <div className="text-3xl">🧭</div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Interactive City Maps</h3>
              <p className="text-gray-600 leading-relaxed">Explore cities with our interactive maps that highlight the best attractions and hidden gems.</p>
            </div>


            {/* <div className="group bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="w-16 h-16 bg-gradient-to-br from-primary/20 to-primary/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <div className="text-3xl">📸</div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Augmented Reality</h3>
              <p className="text-gray-600 leading-relaxed">Point your camera at landmarks to get instant information and historical context.</p>
            </div> */}

            {/* <div className="group bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="w-16 h-16 bg-gradient-to-br from-primary/20 to-primary/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <div className="text-3xl">🌙</div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Offline Mode</h3>
              <p className="text-gray-600 leading-relaxed">Download city guides for offline use to avoid roaming charges while traveling.</p>
            </div> */}

            <div className="group bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="w-16 h-16 bg-gradient-to-br from-primary/20 to-primary/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <div className="text-3xl">✨</div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Chat with AI</h3>
              <p className="text-gray-600 leading-relaxed">Curious to know more? Chat with <span className="font-bold text-teal-600">Jasmine</span>, our AI travel assistant to instantly get your curiosity satisfied.</p>
            </div>

            <div className="group bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="w-16 h-16 bg-gradient-to-br from-primary/20 to-primary/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <div className="text-3xl">💡</div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Local Tips</h3>
              <p className="text-gray-600 leading-relaxed">Get to know FAQs, tips, and trivia about the attractions and local culture you experience in your journey.</p>
            </div>

            <div className="group bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="w-16 h-16 bg-gradient-to-br from-primary/20 to-primary/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <div className="text-3xl">✈️</div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Get Inspired</h3>
              <p className="text-gray-600 leading-relaxed">Where to travel next? Get inspired by our curated list of desinations and attractions.</p>
            </div>

            <div className="group bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="w-16 h-16 bg-gradient-to-br from-primary/20 to-primary/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <div className="text-3xl">📝</div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                <span>Trip Planner</span>
                <span className="ml-3 bg-teal-100 text-teal-800 text-xs font-light px-2.5 py-1 rounded-full">Coming soon</span>
              </h3>
              <p className="text-gray-600 leading-relaxed">Create custom travel plans based on your interests, time, and budget.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Screenshots Section with modern design */}
      <section className="py-32 bg-white">
        <div className="max-w-7xl mx-auto px-5">
          {/* Section Header */}
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              TravelMaker in Action
            </h2>
            <div className="w-24 h-1 bg-primary mx-auto rounded-full mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Get a glimpse of our intuitive interface and powerful features
            </p>
          </div>

          {/* Screenshots Grid with enhanced design */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative rounded-3xl overflow-hidden shadow-xl group-hover:shadow-2xl transition-all duration-300 transform group-hover:-translate-y-2">
                <img
                  src="/images/homepage.png"
                  alt="TravelMaker app screenshot - Map view"
                  className="w-full h-auto block transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="text-center my-4">
                <h3 className="font-semibold text-gray-900">Get Inspired</h3>
                <p className="text-sm text-gray-600">Where to travel next?</p>
              </div>
            </div>
            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative rounded-3xl overflow-hidden shadow-xl group-hover:shadow-2xl transition-all duration-300 transform group-hover:-translate-y-2">
                <img
                  src="/images/cairo-map.png"
                  alt="TravelMaker app screenshot - Map view"
                  className="w-full h-auto block transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="text-center my-4">
                <h3 className="font-semibold text-gray-900">Interactive Maps</h3>
                <p className="text-sm text-gray-600">Explore with ease</p>
              </div>
            </div>

            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative rounded-3xl overflow-hidden shadow-xl group-hover:shadow-2xl transition-all duration-300 transform group-hover:-translate-y-2">
                <img
                  src="/images/listen-khufu.png"
                  alt="TravelMaker app screenshot - Attraction details"
                  className="w-full h-auto block transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="text-center my-4">
                <h3 className="font-semibold text-gray-900">Listen to Audio Guides</h3>
                <p className="text-sm text-gray-600">Rich content</p>
              </div>
            </div>

            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative rounded-3xl overflow-hidden shadow-xl group-hover:shadow-2xl transition-all duration-300 transform group-hover:-translate-y-2">
                <img
                  src="/images/jasmine.png"
                  alt="TravelMaker app screenshot - Audio guide"
                  className="w-full h-auto block transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="text-center my-4">
                <h3 className="font-semibold text-gray-900">Chat with Jasmine</h3>
                <p className="text-sm text-gray-600">Ask about destinations</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-5">
          {/* Section Header */}
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Follow Us
            </h2>
            <div className="w-24 h-1 bg-primary mx-auto rounded-full mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Stay connected with us on social media for the latest updates and travel inspiration!
            </p>
          </div>

          <div className="flex justify-center space-x-8 mb-20">
            <a href="https://www.tiktok.com/@travelmaker.app/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-900 transition-colors duration-300">
              <img src="/images/tiktok.png" alt="TikTok" className="h-16 w-16" />
            </a>
            <a href="https://www.facebook.com/travelmakerapp/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-900 transition-colors duration-300">
              <img src="/images/facebook.png" alt="Facebook" className="h-16 w-16" />
            </a>
            <a href="https://www.instagram.com/travelmaker.app/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-900 transition-colors duration-300">
              <img src="/images/instagram.png" alt="Instagram" className="h-16 w-16" />
            </a>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-5">
          {/* Section Header */}
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Powered by
            </h2>
            <div className="w-24 h-1 bg-primary mx-auto rounded-full mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              TravelMaker is powered by state of the art text-to-speech product in the industry
            </p>
          </div>

          <div className="flex justify-center">
            <div href="https://elevenlabs.io/startup-grants">
              <img
                src="https://eleven-public-cdn.elevenlabs.io/payloadcms/pwsc4vchsqt-ElevenLabsGrants.webp"
                alt="ElevenLabs"
                className="w-[700px] h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section with modern gradient design */}
      <section className="relative py-32 bg-gradient-to-br from-primary via-primary to-blue-600 text-white text-center overflow-hidden">
        {/* Background decorations */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-80 h-80 bg-white/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>
          <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-white/5 rounded-full blur-2xl -translate-x-1/2 -translate-y-1/2"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto px-5">
          {/* CTA Badge */}
          <div className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium mb-8">
            <span className="w-2 h-2 bg-white rounded-full mr-2 animate-pulse"></span>
            Join thousands of happy travelers
          </div>

          {/* CTA Title */}
          <h2 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Ready to Start Your Journey?
          </h2>

          {/* CTA Subtitle */}
          <p className="text-xl md:text-2xl mb-12 opacity-90 leading-relaxed max-w-3xl mx-auto">
            Download TravelMaker today and get the best audio guide you will ever need.
            Your next journey is just a tap away.
          </p>

          {/* Enhanced Button Group */}
          <div className="flex gap-6 justify-center md:flex md:gap-6 max-md:justify-center max-md:flex-col max-md:items-center mb-12">
            <a
              href="https://apps.apple.com/app/travelmaker-ai/id6742571605"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-2xl"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                alt="Download on the App Store"
                className="h-15 w-44 object-contain block"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.comrades.travelmaker"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-2xl"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                className="h-15 w-44 object-contain block"
              />
            </a>
          </div>

          {/* Social proof */}
          <div className="flex items-center justify-center gap-8 text-sm opacity-80 max-md:flex-col max-md:gap-4">
            {/* <div className="flex items-center gap-2">
              <span className="text-yellow-400">⭐⭐⭐⭐⭐</span>
              <span>4.8/5 App Store Rating</span>
            </div>
            <div className="flex items-center gap-2">
              <span>📱</span>
              <span>100,000+ Happy Users</span>
            </div> */}
            <div className="flex items-center gap-2">
              <span>🌍</span>
              <span>Available in 20+ Cities</span>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
